export enum TabNames {
    RequirementDetails  = 'Requirement Details ',
    Properties = 'Properties',
    Timeline = 'Timeline',
    Versions = 'Versions',
    ConnectedProposal = 'Connected Proposal',
    People = 'People',
    Log = 'Log',
}
export enum PropertyTabNames {
  SearchProperty  = 'Search Property',
  ShortListedProperty = 'Short Listed Property',
  Log = 'Log',
}

export enum PropertyDetailTabNames {
  Overview  = 'Overview',
  UnitInfo = 'Unit/Tenant Info',
  LocationMap = 'Location Map',
  Log = 'Log',
  Activities = 'Activities',
}
  
export enum ViewTypes {
  List  = 'List',
  Occupation = 'Occupation',
  Timeline = 'Timeline',
}

export enum ActivityCategory {
  Company = 'company',
  Lead = 'lead',
  Customer = 'customer',
  Project = 'project',
  Property = 'property',
}

export enum RequirementStageStatus {
  AddedToShortlist = 'Added to shortlist',
  ProposalCreated = 'Proposal Created',
  ProposalRejected = 'Proposal Rejected',
  ProposalApproved = 'Proposal Approved',
}
  